import { render } from "./ResourceManager.vue?vue&type=template&id=131a3ecc&scoped=true"
import script from "./ResourceManager.vue?vue&type=script&lang=js"
export * from "./ResourceManager.vue?vue&type=script&lang=js"

import "./ResourceManager.vue?vue&type=style&index=0&id=131a3ecc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131a3ecc"]])

export default __exports__